<template>
    <div class="page-box">
        <div class="banner">
            <!-- 放banner 图片 -->
            <a :href="bannerList.tb_url" target="_blank">
                <img :src="bannerList.tb_image_url" alt="" :data-url="bannerList.tb_url">
            </a>

        </div>

        <div class="content-box" v-loading="listLoading">
            <div class="tab-box df">
                <!-- swiper -->
                <div class="f1 mr-36">
                    <swiper :options="swiperOption" ref="topthumbsSwiper">
                        <swiper-slide v-for="(item, index) in tabdata" :key="index">
                            <div class="swiper-slide-box" @click="onSlideClick(index, item.tebc_id)">
                                <span class="text cup fs-20 lh-28" :class="{ 'active': thumbsindex == index }">{{
                                    item.tebc_name }}</span>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <el-button type="primary" class="fn contribute-btn" @click="submitEbook()">
                    <span class="iconfont icon-jia1"></span>
                    {{ $t('我要投稿') }}
                </el-button>
            </div>

            <!-- 列表 -->
            <div class="journal-box list-box df fww">
                <div class="list cup df" v-for="(item, index) in listdata" :key="index"
                    @click="item.teb_type == 10 && $navigate('/journal/info', item.teb_id)">
                    <!-- 人物头像 -->
                    <div class="avatar-box fn">
                        <!-- 给这个图片添加默认图 -->
                        <el-image :src="item.teb_thumb" style="width: 100%;height: 100%;" fit="cover">
                            <div slot="error" class="image-slot">
                                <img src="@/assets/images/news-default.png"
                                    style="width: 100%;height: 100%;object-fit: cover" alt="">
                            </div>
                        </el-image>

                        <!-- <img :src="item.teb_thumb1" alt="" :data-default-src="require('@/assets/images/news-default.png')"> -->
                        <!-- 给这个图片添加默认图 -->
                    </div>

                    <div class="text-box f1 pt-21 pl-24 pr-24 over-h df fdc">
                        <div class="t1 tow-text">
                            <span class="one-text fn d1 mr-4" v-if="item.teb_type == 10">【{{ item.teb_num }}】</span>
                            <span class="fw-b">{{ item.teb_title }}</span>
                        </div>
                        <div class="f1">
                            <!-- <div class="desc three-text fs-14 lh-26">
                                这里一段期刊的关键词总结关键词总结关键词总结关键词总结关键词总结关键词总结关键词总结关键词总结关键词总结关键词总结
                            </div> -->
                            <div class="dl1 df fww">
                                <span v-for="(keyword, index) in item.teb_keywords" :key="index" class="l1 one-text">
                                    {{ keyword }}
                                </span>
                            </div>
                        </div>

                        <!-- 日期 -->
                        <div class="df aic jcsb mb-4">
                            <div class="df aic ">
                                <span class="iconfont icon-Stroke-1 c-3 fs-19"></span>
                                <span class="fs-14 c-19 ml-6">{{ item.teb_published_time }}</span>
                            </div>

                            <el-button type="text" class="download-btn" @click="download($event, item)">{{ $t('马上下载')
                                }}</el-button>
                        </div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="no-data" v-if="listdata.length == 0">
                    <img src="@/assets/images/empty_data.png" alt="">
                    <p>{{ $t('暂无数据') }}</p>
                </div>
            </div>

        </div>


        <!-- 发布投稿 -->
        <ebookApplyModel ref="ebookDialog" @ebook-submitted="handleEbookSubmitted" :data="data_list" />

        <!-- 投稿成功 -->
        <el-dialog title="" width="500px" top="10vh" :visible.sync="isVisible" @close="isVisible = false"
            :close-on-click-modal="false" class="success-dialog">

            <div class="df jcc">
                <img src="@/assets/images/journal-nodata.png" class="ml-20" alt="">
            </div>
            <div class="d1 mic-semblod ta-c fs-18 lh-26">
                {{ $t('投稿成功') }}
            </div>
            <div class="d2 fs-14 lh-22 mt-16">
                <p>{{ $t('感谢您的精彩投稿！✨我们的编辑团队正在快马加鞭审核中，请稍候~') }}</p>
                <p>{{ $t('如有任何修改建议，会第一时间与您联系沟通哒！') }}</p>
            </div>

        </el-dialog>


    </div>
</template>

<script>
// 接口
import { getEbookCategory, getEbookList, addEbookApply } from "@api/ebook";
import ebookApplyModel from "./ebookApplyModel.vue";
import { getcommonData } from "@api/home";
import { getBanner, getMyInfo } from "@api/home";
import "swiper/css/swiper.css";
export default {
    components: { ebookApplyModel },
    data() {
        return {
            isVisible: false,
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                normalizeSlideIndex: false,
                watchSlidesVisibility: true,/*避免出现bug*/
            },

            thumbsindex: 0,

            // 期刊类型
            tabdata: [],

            // 列表数据
            listdata: [],


            // 缓存数据
            datalist: {},
            searchForm: {
                sort_method: 0,
            },
            // 分页
            pagination: {
                page: 1,
                total: 10,
                last_page: 1,
            },
            listLoading: false,
            data_list: [],
            bannerList: [
                { tb_image_url: '', tb_url: '/' },
            ],
            userinfo: [],
        }

    },
    mounted() {
        // 获取初始化数据
        this.getData();
        this.getBannerList();
        this.getCurrUserData();
    },
    created() {
        setTimeout(() => {
            this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
        }, 600);
        //this.getData();
    },
    methods: {

        async getData() {
            const res = await getEbookCategory({ pid: null });
            this.tabdata = res.data;

            if (!this.searchForm.tebc_id && this.tabdata.length > 0) {
                // 默认选择第一个
                this.thumbsindex = 0;

                this.searchForm.tebc_id = this.tabdata[0].tebc_id;
            }
            this.getEbookListData();
        },
        async getBannerList() {
            let res = await getBanner({ dd_id: 50 });
            if (res.status == 200 && res.data.length > 0) {
                this.bannerList = res.data[0];
                //console.log(this.bannerList)
            }

        },
        async getEbookListData() {
            this.listLoading = true;
            const resList = await getEbookList({
                ...this.searchForm,
                page: this.pagination.page,
            });


            if (resList.status == 200) {
                this.pagination.total = resList.data.ebookList.total;
                this.listdata = resList.data.ebookList.data;
                this.pagination.last_page = resList.data.ebookList.last_page;
            }
            this.listLoading = false;
        },
        onSlideClick(index, tebc_id) {
            this.thumbsindex = index;
            const topthumbsSwiper = this.$refs.topthumbsSwiper.$swiper;
            topthumbsSwiper.slideTo(index);
            this.searchForm.tebc_id = tebc_id;
            this.getEbookListData();
        },
        download(event, params) {
            event.stopPropagation();
            console.log(this.$refs, "...");
            if (this.userinfo.length == 0) {
                sessionStorage.clear();
                setTimeout(() => {
                    let str = "/cn";

                    let Language = localStorage.getItem('currentLanguage');  //获取本地语言
                    if (Language && Language != 'zh') {
                        str = '/en';
                    } else {
                    }

                    const parsedUrl = new URL(window.location.href);
                    const path = parsedUrl.pathname; // This will give you the path

                    const url = str + '/login?callback=' + path; // 你想要跳转的 URL
                    window.open(url);
                }, 1000);
                return;
            }

            window.location.href =
                "/protal/download/downAnnex?content_id=" +
                params.teb_id +
                "&att_id=" +
                params.teb_annex[0].att_id +
                "&type=110";
        },
        async submitEbook() {
            this.thisUserInfo = JSON.parse(localStorage.getItem('userinfo'));
            if (this.thisUserInfo.user_id === undefined || this.thisUserInfo.user_id < 1) {
                this.$jumpLogin();
                return false;
            }
            let res = await getcommonData();
            if (res.status == 200) {
                this.data_list = res.data;
            }
            this.$refs.ebookDialog.openModal();
        },
        // 发布投稿
        async handleEbookSubmitted(content) {
            this.$bus.$emit('showLoading', this.$t('加载中') + '...')
            let res = await addEbookApply(content);
            if (res.status == 200) {
                // this.$message.success(res.msg);
                this.isVisible = true;
            }
            this.$bus.$emit('hideLoading')
        },
        async getCurrUserData() {
            let res = await getMyInfo();
            if (res.status == 200) {
                this.userinfo = res.data;
            }
        },
    }

}
</script>

<style lang="scss" scoped>
// 投稿成功 弹框
::v-deep() {
    .success-dialog {
        .el-dialog {
            border-radius: 12px;
        }

        .el-dialog__header .el-dialog__title {
            display: none;
        }

        .el-dialog__headerbtn .el-dialog__close {
            font-size: 24px;
            color: #191919;

            &:hover {
                color: #B7251E;
            }
        }

        .d1,
        .d2 {
            color: #1a1a1a;
        }
    }
}

.contribute-btn {
    min-width: 95px;
    height: 28px;
    line-height: 26px;
    padding: 0 16px;
    border: 0.5px solid rgb(183, 37, 30);
    border-radius: 20px;
    font-size: 14px;
    background: rgb(183, 37, 30);

    &:hover {
        background: #DD736D;
        border-color: #DD736D;
    }

    .iconfont {
        font-size: 12px;
        position: relative;
        top: -1px;
    }
}

.journal-box {
    max-width: 1600px;
    margin: 0 auto;

    .list {
        width: calc(33.33% - 11px);
        // height: 224px;
        padding-bottom: 1.5%;
        border-radius: 6px;

        // background: rgb(255, 255, 255);
        background: transparent;
        margin-right: 16px;
        margin-top: 60px;
        position: relative;
        padding-left: 2.04%;

        // z-index: 100;
        &::before {
            content: "";
            display: block;
            width: calc(100% - 16px);
            border-radius: 100px 6px 6px 6px;
            height: 100%;
            position: absolute;
            left: 16px;
            top: 0;
            background: #ffffff;
            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
        }

        &::after {
            content: "";
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background-image: url("../../assets/images/ebook-role.png");
            background-size: auto 100%;
            background-repeat: no-repeat;
        }

        .dl1 {
            margin-top: 12px;
            max-height: 91px;

            overflow-y: scroll;

            // 删除滚动条 并兼容火狐浏览器
            &::-webkit-scrollbar,
            &::-webkit-scrollbar-track {
                display: none;
            }

            &::-webkit-scrollbar {
                display: none;
            }

            .l1 {
                font-size: 12px;
                color: #191919;
                min-width: 56px;
                height: 24px;
                line-height: 24px;
                padding: 0 6px;
                text-align: center;
                border-radius: 4px;
                background: rgba(0, 0, 0, 0.05);
                margin-right: 12px;
                margin-bottom: 8px;
            }
        }

        &:nth-child(3n) {
            margin-right: 0;
        }

        .text-box {
            position: relative;
            z-index: 10;

            .t1 {
                min-height: 26px;
                font-size: 16px;
                color: #191919;
                transition: all .36s;

                .d1 {
                    display: inline-block;
                    max-width: 100%;
                    font-size: 12px;
                    line-height: 20px;
                    padding: 0px 2px;
                    color: #ffffff;
                    border-radius: 4px;
                    background: rgb(183, 37, 30);
                    position: relative;
                    top: 3px;
                }
            }

            .desc {
                height: 78px;
                margin-top: 12px;
                color: #191919;
            }

            .download-btn {
                padding: 0;
                color: #2673E5;

                &:hover {
                    opacity: 0.8;
                }
            }
        }

        &:hover {
            .text-box .t1 {
                color: #B7251E;
            }

            .avatar-box {

                img {
                    transform: scale(1.1);
                }
                ::v-deep .el-image {
                    transform: scale(1.1);
                }
            }



        }


        .avatar-box {
            background: #ffffff;
            width: 33.718%;
            height: 0;
            border-radius: 6px;
            padding-bottom: 48.17%;
            // background: #2673E5;
            // width: 168px;
            // height: 240px;
            box-shadow: 2px 5px 16px rgba(0, 0, 0, 0.12);
            position: relative;
            margin-top: -8%;
            z-index: 10;
            overflow: hidden;

            ::v-deep .image-slot {
                width: 100%;
                height: 100%;

                img {
                    transition: all .36s;
                }
            }

            ::v-deep .el-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 6px;
                position: absolute;
                top: 0;
                left: 0;
                transition: all 1s;

                &:hover {
                    transform: scale(1.1);
                }
            }
        }
    }
}

.tab-box {
    max-width: 1600px;
    margin: 0 auto;
    margin-top: 40px;

    .text {
        color: #595959;
        transition: 'color' .36s;
        position: relative;
        display: block;
        padding-bottom: 6px;

        &:hover {
            color: #191919;
            font-weight: 500;
        }

        &.active {
            color: #191919;
            font-weight: 500;

            &::after {
                content: "";
                display: block;
                width: 28px;
                height: 3px;
                border-radius: 4px;
                background: rgb(183, 37, 30);
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }

}

.content-box {
    padding: 0 80px 220px;
}

::v-deep() {
    .swiper-slide {
        width: auto !important;
    }
}

.page-box {
    margin-top: 60px;

    .banner {
        //min-height: 400px;
        //max-height: 700px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}

// 媒体查询
@media screen and (max-width: 1480px) {
    .journal-box .list .text-box .desc {
        height: 52px !important;
        // 设置两行溢出溢出省略号
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; // 限制行数为2
        -webkit-box-orient: vertical;
    }
}

@media screen and (max-width: 1280px) {
    .journal-box .list .text-box .desc {
        height: 78px !important;
        // 设置两行溢出溢出省略号
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3; // 限制行数为2
        -webkit-box-orient: vertical;
    }

    .journal-box .list {
        width: calc(50% - 12px) !important;

        // margin-right: 0;
        &:nth-child(2n) {
            margin-right: 0;
        }

        &:nth-child(3n) {
            margin-right: 16px;
        }
    }
}
</style>